import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyProjectSettingsOpsgenieRoute: InvariantJiraRoute = {
	name: 'legacy-project-settings-opsgenie',
	path: '/plugins/servlet/project-config/:projectKey/opsgenie',
};
